import script from "./SendQuoteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SendQuoteModal.vue?vue&type=script&setup=true&lang=js"

import "./SendQuoteModal.vue?vue&type=style&index=0&id=71a2652f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a2652f"]])

export default __exports__